import { UserCircleIcon, } from "@heroicons/react/24/outline"; // Heroicons v2
import createIcon from "./createIcon";

const User = createIcon(UserCircleIcon, "User");

export default User;